import { useEffect, useState, useRef } from "react";
import ReactAudioPlayer from 'react-audio-player';
import sampleAudio from '../../assets/SampleAudioTest.mp3';
import './AudioContent.css';
import {
    PauseButton,
    PlayButton,
    SquareIcon,
    ExportBlueIcon, SaveIcon, FileBlueIcon, arrowIconBlue
} from "../../assets";
import ApiServices from "../../utils/apiServices";

const AudioContent = (props) => {
    //const [isPlaying ,setIspalying] = useState(false);
    const [trackProgress, setTrackProgress] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [, setLegacyFolderData] = useState([]);
    const [, setLegacyDocumentData] = useState([]);
    const [displayNew, setDisplayNew] = useState(false);
    const [, setNewTextFileClick] = useState(false);
    const [, setNewLexiconFileClick] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            let service = new ApiServices();
            let res1 = await service.getAllDocDetails();
            let res2 = await service.getAllFolderDetails();
            if (res1) {
                setLegacyDocumentData(res1)
            }
            if (res2) {
                setLegacyFolderData(res2)
            }
        };

        fetchData();
    }, [])

    const folderStructure = props.foldername;
    const fileSelected = props.selectedDocument;

    const audioSrc = useRef(new Audio(sampleAudio));
    const intervalRef = useRef();
    const isReady = useRef(false);
    const { duration } = audioSrc.current;
    //---------------------function------------------
    const startTimer = () => {
        // Clear any timers already running
        clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
            if (audioSrc.current.ended) {
                setTrackProgress(0)
            } else {
                setTrackProgress(audioSrc.current.currentTime);
            }
        }, 1000);
    };

    const onScrub = (value) => {
        // Clear any timers already running
        clearInterval(intervalRef.current);
        audioSrc.current.currentTime = value;
        setTrackProgress(audioSrc.current.currentTime);
    };

    const onScrubEnd = () => {
        // If not already playing, start
        if (!isPlaying) {
            setIsPlaying(true);
        }
        startTimer();
    };
    useEffect(() => {
        if (isPlaying) {
            audioSrc.current.play();
            startTimer();
        } else {
            audioSrc.current.pause();
        }
    }, [isPlaying]);

    useEffect(() => {
        // Pause and clean up on unmount
        return () => {
            audioSrc.current.pause();
            clearInterval(intervalRef.current);
        };
    }, []);

    const onPlayClick = () => {
        setIsPlaying(true);
        audioSrc.current.play();
    }
    const onPauseClick = () => {
        setIsPlaying(false);
        audioSrc.current.pause();
    }
    return (<>
        <div className="page-layout">
            <div className="ms-Stack container-337" style={{ width: "100%" }}>
                <div className="fixedPaneContainer-162" style={{ width: "200px" }}>
                    <div className="file-tree-panel-pnpi7ihwoh">
                        <span className="sc-dnqmqq jteVcr nav-callout-wrapper-i4cd0385ia">
                            <div>
                                <nav className="ms-Nav selected-root-parent root-300">
                                    <div className="ms-Nav-group is-expanded">
                                        <button className="ms-Nav-chevronButton chevronButton-304">
                                            <img className='Icon-482' src={arrowIconBlue} alt="Expand" />
                                            All Files
                                        </button>
                                        <div>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                        </span>
                    </div>
                </div>
                <div tabIndex="0" className="css-338"></div>
                <div className="ms-StackItem flexiblePane-340">
                    <div className="ms-StackItem css-262" style={{ height: "100%" }}>
                        <div className="ms-StackItem css-341">
                            <div className="banner"></div>
                            <div style={{ height: "37px", display: "flex" }}>{folderStructure.map((value) => {
                                return (
                                    <div className="container-top"><button className="button-123"
                                    >{value}</button><span>{'>'}</span></div>
                                )
                            })}</div>
                            <div className="main wrapper">
                                <div className="ms-Stack editor-panel">
                                    <div className="tuning-command-bar-ur8d2yznta flex-row">
                                        <span className="button-bar">
                                            <div style={{ position: "relative" }}>
                                                <div className="ms-FocusZone">
                                                    <div className="ms-OverflowSet ms-CommandBar-primaryCommand primarySet-192">
                                                        <div className="ms-OverflowSet-item item-193">
                                                            <button style={{ backgroundColor: "white" }} onClick={() => setDisplayNew(true)}
                                                                onMouseLeave={() => setDisplayNew(false)}>
                                                                <span className="ms-Button-flexContainer flexContainer-177">
                                                                    <img className="icon-345" src={FileBlueIcon} alt="File" />
                                                                    <span className="ms-Button-textContainer textContainer-178">
                                                                        <span className="ms-Button-label label-346" id="id__334">File</span>
                                                                    </span>
                                                                    {(displayNew) ?
                                                                        <img src={arrowIconBlue} alt="Collapse" style={{ transform: "rotate(180deg)" }} />
                                                                        :
                                                                        <img src={arrowIconBlue} alt="Expand" />
                                                                    }
                                                                </span>
                                                                {(displayNew) && <ul className="TSS-sub-wrapper-menu">
                                                    <li onClick={() => setNewTextFileClick(true)}>New Text File</li>
                                                    <li onClick={() => { setNewLexiconFileClick(true) }}>New Lexicon File</li>
                                                </ul>}
                                                            </button>
                                                        </div>
                                                        <div className="ms-OverflowSet-item item-193">
                                                            <button style={{ backgroundColor: "white" }}>
                                                                <span className="ms-Button-flexContainer flexContainer-177">
                                                                    <img className="icon-345" src={SaveIcon} alt="Save" />
                                                                    <span className="ms-Button-textContainer textContainer-178">
                                                                        <span className="ms-Button-label label-346" id="id__334">Save
                                                                        </span>
                                                                        <span className="css-534" aria-hidden="true"></span>
                                                                    </span>
                                                                    <img className="" src={arrowIconBlue} alt="Expand" />
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className="ms-OverflowSet-item item-193">
                                                            <button style={{ backgroundColor: "white" }}>
                                                                <span className="ms-Button-flexContainer flexContainer-177">
                                                                    <img className="icon-345" src={ExportBlueIcon} alt="Export" />
                                                                    <span className="ms-Button-textContainer textContainer-178">
                                                                        <span className="ms-Button-label label-346" id="id__334">Export</span>
                                                                    </span>
                                                                    <img src="" alt="" />
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className="ms-OverflowSet-item item-193">
                                                            <button style={{ backgroundColor: "white" }}>
                                                                <span className="ms-Button-flexContainer flexContainer-177">
                                                                    <img src="" alt="" />
                                                                    <span className="ms-Button-textContainer textContainer-178">
                                                                        <span className="ms-Button-label label-346" id="id__334">...</span>
                                                                    </span>
                                                                    <img src="" alt="" />
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                    <div className="audio-player">
                                        <div className="audio-player-wrapper">
                                            <div className="synthesis-audio-player-container"
                                                style={{ display: "flex" }}>
                                                {isPlaying ? (
                                                    <button
                                                        type="button"
                                                        className="circlebutton"
                                                        onClick={() => onPauseClick()}
                                                        aria-label="Pause"
                                                    ><span className="flexContainer-177">
                                                            <img src={PauseButton} alt="Pause" />
                                                        </span>
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="circlebutton"
                                                        onClick={() => onPlayClick()}
                                                        aria-label="Play"
                                                    >
                                                        <span className="flexContainer-177">
                                                            <img src={PlayButton} alt="Play" />
                                                        </span>
                                                    </button>
                                                )}
                                                <div style={{ display: "flex" }}>
                                                    <button
                                                        type="button"
                                                        className="circlebutton"
                                                        aria-label="Pause"
                                                        onClick={() => onPauseClick()}
                                                    >
                                                        <span className="flexContainer-177"><img src={SquareIcon} alt="Stop" /></span>
                                                    </button>
                                                    < div className="play-bar-wrap">
                                                        <span>{trackProgress}</span>
                                                        <input
                                                            type="range"
                                                            value={trackProgress}
                                                            step="1"
                                                            min="0"
                                                            max={duration ? duration : `${duration}`}
                                                            className="progress"
                                                            onChange={(e) => onScrub(e.target.value)}
                                                            onMouseUp={() => onScrubEnd()}
                                                            onKeyUp={() => onScrubEnd()}
                                                            style={{
                                                                backgroundColor: "#c7e0f4",
                                                                minWidth: "269px",
                                                                marginTop: "5px",
                                                                display: "inline-block"
                                                            }}
                                                        />
                                                        <span>{duration}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ms-StackItem content-editor-wrapper css-393">
                                        <div className="ms-Stack container-394">
                                            <div className="ms-StackItem flexiblePane-396">
                                                <div className="content-editor theme-tuning multi-color">
                                                    <div className="editor-view-text notranslate">
                                                        <textarea style={{ width: "100%", minHeight: "300px" }}>{fileSelected.doctext}</textarea></div>
                                                </div>
                                            </div>
                                            <div tabIndex="0" className="css-517"></div>
                                            <div className="fixedPaneContainer-162 consoleWrapper-164" style={{ height: "80px" }}>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="tuning-footer-98cfl5vjew"><div className="counter"><label>Total characters:</label><b><span >63</span> / 20,000</b></div><div className="counter"><span id="qs-billable-chars"><span>Billable characters</span>: </span><b><span>N/A</span> </b></div></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default AudioContent;